import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import commonNetwork from "../../common/api/commonNetwork"; 
import { FetchResultType } from "../fetchTypes";
export const getOrderSummaryTotal = createAsyncThunk(
  "/orderSummaryTotal/get",
  async (params:any, { rejectWithValue }) => {
    try {
      // authToken eklenecek cookie,local vs biryerden okunup
      const { data, errorMessage, isSuccess } = await commonNetwork.get("/dashboard/order-summary-card", params);
      if (isSuccess ) {
        return data;
      } else {
        return rejectWithValue(data);
      }
    } catch (e: any) {
      return rejectWithValue(e.data.message);
    }
  }
);

export type OrderSummaryTotal={
  todayCheckout?:number,
  weekCheckout?:number,
  monthCheckout?:number,
  yearCheckout?:string
}

export interface OrderSummaryTotalStateType extends FetchResultType {
  orderSummaryTotal: OrderSummaryTotal,
}

export const orderSummaryTotalSlice = createSlice({
  name: "vplist",
  initialState: {
    orderSummaryTotal: [],
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: "",
  },
  reducers: {
    clearState: (state) => {
      state.orderSummaryTotal = [];
      state.isFetching = false;
      state.isSuccess = false;
      state.isError = false;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getOrderSummaryTotal.fulfilled, (state, { payload }) => {
      state.orderSummaryTotal = payload;
      state.isFetching = false;
      state.isSuccess = true;
      state.isError = false;
      return state;
    });
    builder.addCase(getOrderSummaryTotal.rejected, (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      // state.errorMessage = payload.message;
    });
    builder.addCase(getOrderSummaryTotal.pending, (state) => {
      state.isFetching = true;
    });
  },
});
export const { clearState } = orderSummaryTotalSlice.actions;

export const orderSummaryTotalSelector = (state: any) => state.orderSummaryTotal;

export const orderSummaryTotalReducer = orderSummaryTotalSlice.reducer;
